module.exports = __webpack_public_path__ + "img/winner-daily.1eec81e8.png";